import React from 'react'

const NotFound = () => {
  return (
    <div>
      <h2>NotFound </h2>
    </div>
  )
}

export default NotFound
